// Faction trust. Resets every loop, unlike ability progression.

import type { FactionId, FactionTrustLevel, LoopState } from "../types"

export const TRUST_ORDER: FactionTrustLevel[] = [
  "unknown",
  "recognized",
  "trusted",
  "subjected",
]

export function getTrust(
  loop: LoopState,
  factionId: FactionId,
): FactionTrustLevel {
  return loop.factionTrust[factionId] ?? "unknown"
}

export function isTrustAtLeast(
  loop: LoopState,
  factionId: FactionId,
  level: FactionTrustLevel,
): boolean {
  return TRUST_ORDER.indexOf(getTrust(loop, factionId)) >= TRUST_ORDER.indexOf(level)
}

export function setTrust(
  loop: LoopState,
  factionId: FactionId,
  level: FactionTrustLevel,
): LoopState {
  return {
    ...loop,
    factionTrust: { ...loop.factionTrust, [factionId]: level },
  }
}

export function raiseTrust(loop: LoopState, factionId: FactionId): LoopState {
  const current = getTrust(loop, factionId)
  const currentIndex = TRUST_ORDER.indexOf(current)
  const nextLevel = TRUST_ORDER[Math.min(currentIndex + 1, TRUST_ORDER.length - 1)]
  return setTrust(loop, factionId, nextLevel)
}
